module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('SubTabs', {
    attrs: {
      "nomeSessao": "Itens",
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('ScheduleModal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b88daf98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/index.vue
// module id = 771
// module chunks = 1